import _ from "lodash";
import { fetch } from "src/services/apollo-fetch";
import { Query } from "./_api";

async function fetchManufacturers(data) {
    const response = await fetch.query({
        query: Query.manufacturerSearch,
        variables: data,
    });
    return response.data.manufacturers;
}

export default {
    searchManufacturers: _.debounce(
        async (context, search) => {
            return await fetchManufacturers({
                limit: 50,
                search,
            });
        },
        500, // 500ms
        { leading: true, trailing: true },
    ),
};
